import { createFileRoute } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';
import { AccountPane } from '@/containers/settings/settings-profile-panes.component';

export const Route = createFileRoute('/settings/account')({
  component: AccountRoute,
});

function AccountRoute() {
  return (
    <AuthCheck>
      <Head heading='Account' />
      <SettingsLayout>
        <AccountPane />
      </SettingsLayout>
    </AuthCheck>
  );
}
